<!--
<avatar-image src="../file.png" size="62" player-id="1774" avatar-class="profile" v-if="chat.playerId > 0"></avatar-image>
-->

<template>
	<div class="heroImage" :class="[avatarClass, playerInfo.sex]">
		<img :src="src" :width="size" :height="size" />
		<!--<img src="//iwstatic.g.bsrv.su/resources/avatars/125/lexinzector.png" width="120" height="120" />-->
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		src: {
			type: String,
			default: '',
		},
		size: {
			type: Number,
			default: 62,
		},
		avatarClass: {
			type: String,
			default: '',
		},
		dead: {
			type: Boolean,
			default: false,
		},
		playerId: {
			type: Number,
			required: true,
		},
		type: {
			type: String,
			default: 'face', //face, body
		},
	},
	data: () => ({
		playerInfo: {
			sex: 'male',
		},
	}),
	computed: {},
	methods: {
		async loadPlayerInfo(){
			//this.playerId
			this.src = '/files/avatars/' + this.type + '/' + this.playerId + '.png';
			//return {};
		},
	},
	async created(){
		await this.loadPlayerInfo();
	},
	components: {},
}
</script>